import customAxios from './customAxios';
import { ADD_NEWS_DATA, SET_NEWS_DATA } from "./types";

export const addNewsData = (newsData) => (dispatch, getState) => {
  dispatch({type: ADD_NEWS_DATA, payload: newsData});
}

export const getNews = () => async (dispatch, getState) => {

  const url = '/vins/VInsV2/public/news/getNewsActive/0/10';  // 0 -> first page, 10 -> 10 records

  let res, payload = [];

  try{
    res = await customAxios.get(url);
  } catch (error) {
    console.log(error);
  }

  if(res?.data && res?.data?.content && !res?.data?.status ) {
    payload = res?.data?.content;

    payload = payload.filter(data => data?.img);

    payload = payload.map(news => {
      return {image: `data:image/png;base64,${news?.img}`, title: news?.title, textData: news?.textData, id:news?.id}
    });
  }

  dispatch({type: SET_NEWS_DATA, payload: payload});
}


/*

export const getNewsData = () => async (dispatch, getState) => {

  const {news: {lastNews}} = getState();

  //const lastNews = [{picRefNo: 1325, title: 'Title' , textData: 'text 1325'}, {picRefNo: 1326, title: 'Title' , textData: 'text 1326'}, {picRefNo: 1327, title: 'Title' , textData: 'text 1327'}]

  if(!lastNews?.length) return;
  //picRefNo, title, textData
  console.log('getNewsdata', lastNews);

  let newsData = lastNews.map(news => {
    
    //console.log(news.img);
    return {image: `data:image/png;base64,${news?.img}`, title: news?.title, textData: news?.textData, id:news?.id}
  })

  newsData = newsData.filter(news => news.title == 'Test Title'); 

  console.log('newsData', newsData)

  dispatch({type: SET_NEWS_DATA, payload: newsData});
}

export const getNewsDataOld = () => async (dispatch, getState) => {

  const {news: {lastNews}} = getState();

  //const lastNews = [{picRefNo: 1325, title: 'Title' , textData: 'text 1325'}, {picRefNo: 1326, title: 'Title' , textData: 'text 1326'}, {picRefNo: 1327, title: 'Title' , textData: 'text 1327'}]

  if(!lastNews?.length) return;
  //picRefNo, title, textData
  console.log('getNewsdata', lastNews)

  const newsData = await Promise.all(lastNews.map(async (news) => {
    const fileUploadId = news?.picRefNo;
    const url = `/syws-file/file/download/${fileUploadId}`;
    let res, file;
    console.log(fileUploadId)

    try{
      res = await customAxios.get(url,  { responseType: 'blob' });
    } catch (error) {
      console.log(error);
    }

    if(res?.data && !res?.data?.status ) {
      file = blobToFile(res.data, news?.title );
    }

    return {image: file, title: news?.title, textData: news?.textData}
  }));


  dispatch({type: SET_NEWS_DATA, payload: newsData});
}


export const getNewsOld = () => async (dispatch, getState) => {

  const url = '/vins/VInsV2/public/news/getNewsActive/0/10';  // 0 -> first page, 10 -> 10 records

  let res, payload = [];

  try{
    res = await customAxios.get(url);
  } catch (error) {
    console.log(error);
  }

  if(res?.data && res?.data?.content && !res?.data?.status ) {
    payload = res?.data?.content;
  }

  dispatch({type: GET_NEWS, payload: payload});
}
*/


